import { connectRefinementList } from "react-instantsearch-dom";
import React from "react";
const SearchIcon = () => (
	<svg
		width="16"
		height="16"
		fill="currentColor"
		className="bi bi-search"
		viewBox="0 0 16 16"
	>
		<path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
	</svg>
);

const RefinementList = ({ items, isFromSearch, refine, searchForItems }) => (
	<>
		<div className="form-group position-relative mt-1 d-block">
			<input
				className="form-control mb-2"
				type="search"
				onChange={(event) => searchForItems(event.currentTarget.value)}
			/>
			<div
				className="border-0 bg-transparent text-black-50 position-absolute top-0 end-0 p-1"
				type="submit"
			>
				<SearchIcon />
				<span className="screen-reader-text">Search</span>
			</div>
		</div>

		<div style={{ position: "relative" }}>
			<div
				style={{
					height: "30px",
					width: "100%",
					background: "linear-gradient(transparent, white)",
					position: "absolute",
					bottom: 0,
					zIndex: 10,
				}}
			></div>
			<div
				style={{
					height: "100px",
					overflowY: "scroll",
					position: "relative",
					paddingBottom: "30px",
				}}
			>
				{items.map((item) => (
					<div className="form-check" key={item.label}>
						<input
							className="form-check-input"
							type="checkbox"
							checked={item.isRefined}
							onChange={() => refine(item.value)}
							id={`jobTitleCheckbox-${item.label}`}
						/>
						<label
							className="form-check-label"
							htmlFor={`jobTitleCheckbox-${item.label}`}
						>
							{item.label}
						</label>
					</div>
				))}
			</div>
		</div>
	</>
);

const JobTitleFilter = connectRefinementList(RefinementList);

// const JobTitleFilter = ({ selectedTitles, setSelectedTitles }) => {
// 	const [{ data, loading, error, response }] = useAxios({
// 		url: "job-title",
// 		baseURL,
// 	});

// 	const [jobTitles, setJobTitles] = useState([]);
// 	const [searchQuery, setSearchQuery] = useState("");

// 	const updateSelectedTitles = (id) => (e) => {
// 		const nextTitles = selectedTitles.includes(id)
// 			? selectedTitles.filter((sId) => sId !== id)
// 			: [...selectedTitles, id];

// 		setSelectedTitles(nextTitles);
// 	};

// 	useEffect(() => {
// 		if (!searchQuery.length) {
// 			setJobTitles(data);
// 		}

// 		const nextTitles =
// 			data?.filter(({ name }) =>
// 				name.toLowerCase().includes(searchQuery.toLowerCase())
// 			) || [];

// 		setJobTitles(nextTitles);
// 	}, [searchQuery]);

// 	useEffect(() => {
// 		if (data?.length) {
// 			setJobTitles(data);
// 		}
// 	}, [data]);

// 	if (loading) {
// 		return <Loader loading={loading} />;
// 	}

// 	if (error) {
// 		return <></>;
// 	}

// 	return (
// 		<>

/* <form className="form-group position-relative mt-1 d-block">
				<input
					className="form-control mb-2"
					type="text"
					name="s"
					id="s"
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
					placeholder="Search..."
				/>
				<button
					className="border-0 bg-transparent text-black-50 position-absolute top-0 end-0 p-1"
					type="submit"
				>
					<SearchIcon />
					<span className="screen-reader-text">Search</span>
				</button>
			</form> */

{
	/* <div style={{ position: "relative" }}>
				<div
					style={{
						height: "30px",
						width: "100%",
						background: "linear-gradient(transparent, white)",
						position: "absolute",
						bottom: 0,
						zIndex: 10,
					}}
				></div>
				<div
					style={{
						height: "100px",
						overflowY: "scroll",
						position: "relative",
						paddingBottom: "30px",
					}}
				>
					{jobTitles.map((title) => (
						<div className="form-check" key={title.id}>
							<input
								className="form-check-input"
								type="checkbox"
								checked={selectedTitles.includes(title.id)}
								onChange={updateSelectedTitles(title.id)}
								id={`jobTitleCheckbox-${title.id}`}
							/>
							<label
								className="form-check-label"
								htmlFor={`jobTitleCheckbox-${title.id}`}
							>
								{title.name}
							</label>
						</div>
					))}
				</div>
			</div> */
}
// 		</>
// 	);
// };

export default JobTitleFilter;
